import { requester } from '../utils';

export const fetchCheckoutsArchive = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/checkout-with-cafe/archives?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchReservesCheckoutById = (checkoutWithCafeId, query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/checkout-with-cafe/reserves/${checkoutWithCafeId}?${query}`,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchCheckoutArchiveDetails = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/checkout-with-cafe/${id}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

